import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as api from "api";
import ActionLink from "components/ActionLink";
import Alert from "components/Alert";
import ZendeskLink from "components/Help/ZendeskLink";
import "./NotificationsBell.css";

export function NotificationsBell() {
    const online = useSelector((state) => state.app.online);
    const { notifications, dismissNotification } = useNotifications();
    const hasNotifications = notifications.length > 0;

    return (
        <>
            <ActionLink id="nav-menu-bell" className="UtilityNav-user-trigger" title={hasNotifications ? `You have ${notifications.length} notification${notifications.length > 1 ? "s" : ""}` : ""}>
                <span className="UtilityNav-user-token">
                    <i className={`icon icon-notification u-textBold ${hasNotifications ? "u-textSuccess" : "u-textCoolBlue"}`} />
                </span>
                {hasNotifications && <span className="NotificationsBell-badge">{notifications.length}</span>}
            </ActionLink>
            <ul className="UtilityNav-user-dropdown">
                <li className="NotificationsBell-list">
                    <div id="nav-menu-bell-notifications" className="NotificationsBell-list-bg">
                        {notifications.map((notification) => (
                            <Alert key={notification.id} type={notification.type || "info"} html={notification.content} onAction={online ? () => dismissNotification(notification.id) : undefined} actionMessage="Dismiss" actionAlignRight />
                        ))}
                        <ZendeskLink title="View all software release notices" url="https://support.overseer.org.nz/hc/en-us/articles/900000877983" className={`IconLink--new-tab u-ml-auto u-mr-sm ${hasNotifications ? "u-mt-sm" : ""}`} />
                    </div>
                </li>
            </ul>
        </>
    );
}

function useNotifications() {
    const dispatch = useDispatch();
    const location = useLocation();
    const [notifications, setNotifications] = useState([]);

    // Fetch notifications when location changes.
    useEffect(() => {
        dispatch(
            api.get({
                path: `messages`,
                onSuccess: (response) => {
                    setNotifications(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    setNotifications([]);
                    return [];
                },
            })
        );
    }, [location, dispatch]);

    const dismissNotification = (id) => {
        dispatch(
            api.put({
                path: `messages/${id}/dismiss`,
                onSuccess: () => {
                    setNotifications((prevState) => prevState.filter((notification) => notification.id !== id));
                    return [];
                },
            })
        );
    };

    return { notifications, dismissNotification };
}
